<template>
  <div v-if="isLockedByOther" style="margin-bottom: 10px; padding: 10px; border-radius: 5px; font-weight: bold;" :style="{ backgroundColor: isLockedByOther ? '#ffeeba' : '#d4edda', color: isLockedByOther ? '#856404' : '#155724' }">
    <i class="fas" :class="isLockedByOther ? 'fa-lock' : 'fa-lock-open'"></i>
    <span v-if="isLockedByOther">
      Tento záznam od {{ startTimeFormatted }} edituje uživatel {{ lockedByUserName }}. Nemůžete provádět změny.
      <span v-if="canForceUnlock">Editace trvá delší dobu: pokud jste si jist, můžete uživatele vyřadit z editace.</span>
      <button v-if="canForceUnlock" class="asd-btn-cancel" style="margin-left: 15px; padding: 2px 10px; font-size: 0.8rem;" @click="forceUnlock" v-help.mouse="'Odemknout záznam (zámek trvá delší dobu)'">
        <i class="fas fa-unlock"></i> Zrušit zámek
      </button>
    </span>
   <!-- <span v-else>Máte tento záznam zamčený pro editaci.</span>-->
  </div>
</template>

<script>
import moment from 'moment'
import EventBus from 'CORE/bus'

export default {
    name: 'EntityLockInfo',
    props: {
        entity: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            now: Date.now(),
            timer: null,
        }
    },
    computed: {
        entityLock() {
            const lock = this.$store.getters.getLock(this.entity)
            if (lock && lock.ttl > 0) return lock
            return null
        },
        isLockedByOther() {
            return this.entityLock && this.entityLock.user !== this.$store.getters.currentUserId
        },
        lockedByUserName() {
            if (this.isLockedByOther) {
                const user = this.$store.getters.userById(this.entityLock.user)
                return user ? user.username : 'Neznámý uživatel'
            }
            return ''
        },
        startTimeFormatted() {
            if (this.entityLock && this.entityLock.startTime) {
                return moment(this.entityLock.startTime).format('HH:mm:ss')
            }
            return ''
        },
        canForceUnlock() {
            this.now; // trigger reactivity
            if (!this.isLockedByOther) return false
            if (!this.entityLock || !this.entityLock.startTime) return false
            // 3600000 ms = 1 hour
            return (Date.now() - this.entityLock.startTime) > 3600000
        },
    },
    mounted() {
        this.timer = setInterval(() => {
            this.now = Date.now()
        }, 60000) // update every minute
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    },
    methods: {
        forceUnlock() {
            if (confirm('Vzdálený uživatel přijde o případnou neuloženou práci. Opravdu?')) {
                EventBus.$emit('PUBLISH_LOCK', { entity: this.entity, ttl: 0 })
            }
        },
    },
}
</script>
